export const fieldConfig = [
    { label: "Math Version", name: "TXBVersion", default: "0" },
    { label: "Reportable Range Min", name: "TXBReportableRangeMin", default: "0" },
    { label: "Reportable Range Max", name: "TXBReportableRangeMax", default: "1000" },
    { label: "Goodness Limit", name: "TXBGoodnessLimit", default: "0.995" },
    { label: "Epsilon", name: "TXBEpsilon", default: "0.0001" },
    { label: "Delta", name: "TXBDelta", default: "1e-10" },
    { label: "Initial B0", name: "TXBInitialB0", default: "0" },
    { label: "Min B0", name: "TXBMinB0", default: "-9999" },
    { label: "Max B0", name: "TXBMaxB0", default: "9999" },
    { label: "Initial B1", name: "TXBInitialB1", default: "1" },
    { label: "Min B1", name: "TXBMinB1", default: "-9999" },
    { label: "Max B1", name: "TXBMaxB1", default: "9999" },
    { label: "Initial B2", name: "TXBInitialB2", default: "-6" },
    { label: "Min B2", name: "TXBMinB2", default: "-9999" },
    { label: "Max B2", name: "TXBMaxB2", default: "9999" },
    { label: "Initial B3", name: "TXBInitialB3", default: "1" },
    { label: "Min B3", name: "TXBMinB3", default: "-9999" },
    { label: "Max B3", name: "TXBMaxB3", default: "9999" },
    { label: "Initial B4", name: "TXBInitialB4", default: "0" },
    { label: "Min B4", name: "TXBMinB4", default: "-9999" },
    { label: "Max B4", name: "TXBMaxB4", default: "9999" },
    { label: "Lambda", name: "TXBLambda", default: "0.5" },
    { label: "N Iterate", name: "TXBNIterate", default: "1000" },
    { label: "Max Error Limit", name: "TXBMaxErrorLimit", default: "100" },
    { label: "Max Rel Error Limit", name: "TXBMaxRelErrorLimit", default: "100" },
    { label: "Max SD Limit", name: "TXBMaxSDLimit", default: "100" },
    { label: "K Exponent", name: "TXBKExponent", default: "2.0" },
    { label: "Cal Level to Ignore", name: "TXBCalLevelToIgnore", default: "0" },
    { label: "Extrema Check 1", name: "TXBExtremaCheck1", default: "0" },
    { label: "Extrema Check 2", name: "TXBExtremaCheck2", default: "0" },
    { label: "Wet Blank Read Multiplier", name: "TXBWetBlankReadMultiplier", default: "1" },
    { label: "Std Total Reagent Volume", name: "TXBStdTotalReagentVolume", default: "1" },
    { label: "Kinetic Prozone Limit", name: "TXBKineticProzoneLimit", default: "0" },
    { label: "Max Response High", name: "TXBMaxResponseHigh", default: "3" },
    { label: "Max Response Low", name: "TXBMaxResponseLow", default: "-3" },
    { label: "Min Response High", name: "TXBMinResponseHigh", default: "3" },
    { label: "Min Response Low", name: "TXBMinResponseLow", default: "-3" },
    { label: "Perform Cal Quality Checks", name: "TXBPerformCalQualityChecks", default: "0" },
    { label: "Monotonicity", name: "TXBMonotonicity", default: "0" },
    { label: "Avg High Level Antigen Excess Check", name: "TXBAvgHighLevelAntigenExcessCheck", default: "0" }
];

// helpers
export const labelToNameMap = Object.fromEntries(
    fieldConfig.map(f => [f.label.toLowerCase(), f.name])
);

export const getLabel = (name) =>
    fieldConfig.find(f => f.name === name)?.label || name;

export const getCleanParameters = (params) => {
    const { TXBParse, ...clean } = params;
    return clean;
};

export const getInitialState = () => {
    const state = {};
    fieldConfig.forEach(f => (state[f.name] = f.default));
    return {
        ...state,
        TXBParse: "",
        afWetResponseAbsoluteErrorMax: "1\n1\n1\n1"
    };
};